<template>
    <GlobalModal
    :modalInfo="{
        class: 'copy-training-modal'
    }"
    @onClose="$emit('close')"
    >
        <template v-slot:customContent>
           <div class="header">
                <span>
                    {{ type == 'copy' ? toLocal('training.copy_training') : toLocal('training.move_training') }}
                </span>
           </div>
           <div class="content-wrapper">
                <div class="loader-container"  v-if="loading">
                    <font-awesome-icon icon="spinner" />
                </div>
               <div class="tree" v-else>
                 
                    <TrainingCopyTreeItem
                        v-for="(item, index) in items"
                        :key="index"
                        :item="item" 
                        childrenKey="items"
                        :level="0"
                        :item_group_id="item_group_id"
                        :checkedList="checked"
                        :checkedSingleValue="checkedSingleValue"
                        :treeType="type"
                        @checkSingleValue="checkedSingleValue = $event"
                    />
               </div>
               <div class="bottom-container">
                <span class="success-message" v-if="copyDoneMessage">{{ copyDoneMessage }}</span>
                <div class="button-container">
                        <button @click="type == 'copy' ? copyTrainingToGroups() : moveTraining()">
                            <span>
                                {{ type == 'copy' ? toLocal('generic.copy') : toLocal('generic.move') }}
                            </span>
                            <svg v-if="!loadingCopy && type == 'copy'" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.75 0H5.75C5.55109 0 5.36032 0.0790178 5.21967 0.21967C5.07902 0.360322 5 0.551088 5 0.75V4.5H1.25C1.05109 4.5 0.860322 4.57902 0.71967 4.71967C0.579018 4.86032 0.5 5.05109 0.5 5.25V17.25C0.5 17.4489 0.579018 17.6397 0.71967 17.7803C0.860322 17.921 1.05109 18 1.25 18H13.25C13.4489 18 13.6397 17.921 13.7803 17.7803C13.921 17.6397 14 17.4489 14 17.25V13.5H17.75C17.9489 13.5 18.1397 13.421 18.2803 13.2803C18.421 13.1397 18.5 12.9489 18.5 12.75V0.75C18.5 0.551088 18.421 0.360322 18.2803 0.21967C18.1397 0.0790178 17.9489 0 17.75 0ZM12.5 16.5H2V6H12.5V16.5ZM17 12H14V5.25C14 5.05109 13.921 4.86032 13.7803 4.71967C13.6397 4.57902 13.4489 4.5 13.25 4.5H6.5V1.5H17V12Z" fill="#333333"/>
                            </svg>
                            <svg v-else-if="!loadingCopy && type == 'move'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.704 6H18.837C16.9005 6 16.9035 3 15.5355 3H7.2945C5.7525 3 4.5 4.2525 4.5 5.796V9H6V5.796C6 5.082 6.582 4.5 7.2945 4.5H15.2505C15.3435 4.644 15.462 4.86 15.5475 5.0205C16.05 5.9475 16.8915 7.5 18.837 7.5H19.704C20.37 7.5 21 8.229 21 9V18.2055C21 18.918 20.418 19.5 19.704 19.5H7.2945C6.582 19.5 6 18.918 6 18.2055V16.5H4.5V18.2055C4.5 19.749 5.7525 21 7.2945 21H19.7025C21.2475 21 22.5 19.749 22.5 18.2055V9C22.5 7.4565 21.2475 6 19.704 6Z" fill="#333333"/>
                                <path d="M11.6564 16.2629L14.7749 13.2194C14.7779 13.2164 14.7794 13.2119 14.7824 13.2074C14.8484 13.1414 14.9039 12.9839 14.9414 12.8969C14.9729 12.8159 14.9849 12.8819 14.9909 12.8009C14.9909 12.7829 14.9999 12.7679 14.9999 12.7514C14.9999 12.7394 14.9939 12.7304 14.9939 12.7199C14.9894 12.6299 14.9729 12.5849 14.9414 12.5009C14.9099 12.4244 14.8589 12.3599 14.8064 12.2984C14.7944 12.2834 14.7884 12.2624 14.7749 12.2489L11.6564 9.13343C11.3564 8.83193 10.8689 8.96993 10.5689 9.27143C10.2674 9.57143 10.2674 10.0589 10.5689 10.3604L12.3704 12.0239L2.30086 12.0254C1.86136 12.0254 1.50436 12.3254 1.50586 12.7499C1.50436 13.1744 1.86136 13.4459 2.30236 13.4459H12.3719L10.5704 15.3104C10.2689 15.6119 10.2689 16.0979 10.5704 16.4009C10.7204 16.5509 10.9154 16.4894 11.1134 16.4894C11.3114 16.4894 11.5079 16.4114 11.6564 16.2629Z" fill="#333333"/>
                            </svg>
                            <font-awesome-icon icon="spinner" v-else />
                        </button>
                    </div>
                    <!-- <div class="options-container">
                        <CheckBox 
                            id="synchro-copy" 
                            v-model="createSynchroCopy"
                            :label="'Sukurti sinchronizuotą kopiją'"
                        />
                    </div> -->
               </div>
            </div>
        </template>
    </GlobalModal>
</template>

<script>
import GlobalModal from "@/components/layout/modals/GlobalModal.vue";
import TrainingCopyTreeItem from "@/components/layout/trainings/TrainingCopyTreeItem.vue";
import CheckBox from '@/components/layout/inputs/CheckBox'
import axios from "axios";

export default {
    name: 'TrainingMoveModal',
    props:{
        item_id:{
            type: [Number,String],
            required: true
        },
        type:{
            type: String,
            default: 'copy' //copy, move
        },
        item_group_id:{
            type: [Number,String],
            default: null
        },
    },
    components:{
        GlobalModal,
        CheckBox,
        TrainingCopyTreeItem
    },
    data(){
        return{
            items:[],
            loading: false,
            checked: [],
            checkedSingleValue: -1,
            createSynchroCopy: false,
            loadingCopy: false,
            copyDoneMessage: null,
            current_training_group_id: null,
        }
    },
    mounted(){
        this.getTrainingFolders();
        this.$route.query.id ? this.current_training_group_id = this.$route.query.id : null;
        if(this.item_group_id){
            this.current_training_group_id = this.item_group_id;
        }
    },
    methods:{
        toggleItem(item){
            let index = this.checked.findIndex(i => i.id === item.id);
            if(index !== -1){
                this.checked.splice(index, 1);
            }else{
                this.checked.push(item.id);
            }
        },
        getTrainingFolders(){
            this.loading = true;
            axios.get( 
                `${this.$store.state.api_link}/training_group/training_groups_tree`,
                this.$store.getters.axiosConfig()
            )
            .then(response => {
                this.items = response.data;
                this.loading = false;

            })
            .catch(error => {
                this.loading = false;
                console.error("Error fetching training folders:", error);
            });
        },
        copyTrainingToGroups(){
            if(this.loadingCopy) return;
            if(this.copyDoneMessage) return;
            if(this.checked.length == 0) return;
            this.loadingCopy = true;
            axios.post( 
                `${this.$store.state.api_link}/training/copy`,
                {
                    training_groups: this.checked,
                    training_id: this.item_id,
                },
                this.$store.getters.axiosConfig()
            )
            .then(response => {
                this.checked = [];
                this.loadingCopy = false;
                this.copyDoneMessage = this.toLocal('training.copy_success_message');
                setTimeout(() => {
                    this.copyDoneMessage = null;
                    this.$emit('close');
                }, 3000);
            })
            .catch(error => {
                this.loadingCopy = false;
            });
        },
        moveTraining(){
            if(this.loadingCopy) return;
            if(this.copyDoneMessage) return;
            if(this.checkedSingleValue == -1) return;
            this.loadingCopy = true;
            axios.post( 
                `${this.$store.state.api_link}/training/move`,
                {
                    training_group: this.checkedSingleValue,
                    training_id: this.item_id,
                    current_training_group: this.current_training_group_id,
                },
                this.$store.getters.axiosConfig()
            )
            .then(response => {
                this.checked = [];
                this.loadingCopy = false;
                this.copyDoneMessage = this.toLocal('training.move_success_message');
                let training_group_index = this.items.findIndex(item => item.id == this.checkedSingleValue);
                if(training_group_index != -1){
                    this.$emit('move', this.items[training_group_index]);
                }
                else{
                    this.$emit('move');
                }
                if(this.item_id == 'all'){
                    this.$emit('close');
                }
                setTimeout(() => {
                    this.copyDoneMessage = null;
                    this.$emit('close');
                }, 3000);
            })
            .catch(error => {
                this.loadingCopy = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.header{
    display: flex;
    width: 100%;
    padding: 0.7rem 1.55rem;
    box-shadow: 0 2px 4px 0 rgba(156, 156, 156, 0.12);
    span{
        font-size: clamp(0.7rem, 1.5vw, 1rem);
        color:#333333;
    }
}
.button-container{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: auto;
}
.bottom-container{
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
}
button{
    display: flex;
    align-items: center;
    background-color: var(--secondary-color);
    gap: 4px;
    padding: 0.4rem 1rem;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    border-radius: 2rem;
    cursor: pointer;
    font-size: clamp(0.7rem, 1.5vw, 0.8rem);
    color:#333;
    border: none;
    transition: all 0.3s ease-in-out;
    svg{
        path{
            transition: all 0.3s ease-in-out;
        }
    }
    &:hover{
        background-color: #333333;
        color: white;
        svg{
            path{
                fill: white;
            }
        }
    }
}
.tree{
    display: flex;
    flex-direction: column;
    max-height: 20rem;
    overflow:auto;
    padding: 1rem 2rem;
    @media (max-width: 1024px){
        max-height:85%;
    }
}
.content-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    padding-bottom: 1rem;
    @media (max-width: 1024px){
        padding-bottom: 4rem;
    }
}
.loader-container{
    display: flex;
    padding: 1rem;
}
.success-message{
    padding: 0 2.4rem;
    color: #5fd75ffa;
    text-align: left;
}
.options-container{
    display: flex;
    justify-content: flex-end;
    padding: 0 1rem;
    margin-top: 0.6rem;
}

</style>